// Package imports:
import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
// Style imports:
import './HomeAlertMassReviewModal.scss'
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import AlertOverview from './AlertOverview';
// Action imports:
import { requestAlertReviewHistory, addAlertReviewHistoryEntry } from '../../redux-store/actions/alertActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { AlertStatus, AlertTickData } from '../../types/api/AlertTypes';

interface IOwnProps {
    show: boolean,
    alerts: AlertTickData[],
    onClear(): void,
    onHide(): void
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

type Tabs = 'New Review' | 'Alert Overview';
const TABS: Tabs[] = ['New Review', 'Alert Overview'];

const HomeAlertMassReviewModal: React.FC<Props> = ({
    show,
    alerts,
    onHide,
    onClear,
    accessTokenV2,
    addAlertReviewHistoryEntry
}) => {
    const [ selectedTab, setSelectedTab ] = useState<Tabs>('New Review');
    const [ comment, setComment ] = useState('');
    const [ newStatus, setNewStatus ] = useState<AlertStatus>('open');

    const closeModal = () => {
        setComment('');
        setNewStatus('open');
        onHide();
    }

    const clearAlerts = () => {
        onClear();
    }

    const alertStatuses: Array<{
        name: string,
        value: AlertStatus
    }> = [{
        name: 'Open',
        value: 'open'
    }, {
        name: 'Watch',
        value: 'watch'
    }, {
        name: 'Investigating',
        value: 'investig'
    }, {
        name: 'Critical',
        value: 'critical'
    }, {
        name: 'Explained',
        value: 'explained'
    }, {
        name: 'Closed',
        value: 'closed'
    }];

    return (
        <Modal
            id='HomeAlertMassReviewModal'
            show={show}
            centered
            backdrop='static'
            size='lg'
            onHide={closeModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Mass review</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className='PanelTabSelector'>
                <div className='BackgroundBar' />
                <div className='PanelTabs'>
                    {
                        // Define your tabs here
                        TABS.map((tabTitle, index) => (
                            <div
                                key={index}
                                onClick={() => setSelectedTab(tabTitle)}
                                className={'PanelTab' + ((selectedTab === tabTitle) ? ' SelectedTab' : '')}
                            >
                                {
                                    (selectedTab === tabTitle)
                                    ? <div className='SelectedTabBackground' />
                                    : null
                                }
                                {tabTitle}
                            </div>
                        ))
                    }
                </div>
            </div>
            {
                // Based on the selected tab, render different content
                (selectedTab === 'New Review') 
                ? (
                    <div className='AlertStatusRadioList'>
                        {alertStatuses.map(({ name, value }) => (
                            <div
                                key={value}
                                className='AlertStatusRadioWrapper'
                                onClick={() => setNewStatus(value)}
                            >
                                <div
                                    className={`AlertStatusRadioButton ${value} ${(value === newStatus) ? 'Selected' : ''}`}
                                >
                                    {
                                        (value === newStatus)
                                        ? (
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className='CheckmarkIcon'
                                            />
                                        ) : null
                                    }
                                </div>
                                <span className='AlertStatusRadioLabel'>{name}</span>
                            </div>
                        ))}
                        <Form.Control
                            as='textarea'
                            className='AlertStatusTextArea'
                            rows={3}
                            placeholder='Type comment'
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                        />
                    </div>
                ) : (
                    <AlertOverview
                        alerts={alerts}
                    />
                )
            }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className='CloseButton'
                    variant='dark'
                    onClick={() => closeModal()}
                >
                    Cancel
                </Button>
                <Button
                    className='SaveButton'
                    variant='dark'
                    onClick={() => {
                        addAlertReviewHistoryEntry(
                            accessTokenV2 || "",
                            (alerts.map(alert => alert.ad_id).filter(alertId => alertId !== undefined) as number[]),
                            comment,
                            newStatus
                        );
                        clearAlerts();
                        closeModal();
                    }}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function mapStateToProps({ alertReducer, loginReducer }: RootState) {
    const { alertReviewHistoryByAlertDataId } = alertReducer;
    const { accessTokenV2 } = loginReducer;
    return {
        accessTokenV2,
        alertReviewHistoryByAlertDataId
    };
}

const connector = connect(mapStateToProps, { requestAlertReviewHistory, addAlertReviewHistoryEntry });
export default connector(HomeAlertMassReviewModal);